module.exports = __webpack_public_path__ + "static/media/GLIDE-Logo-White.e44f4f20.png";